import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { isAuthenticated } from 'selectors/user/session'
import { getABTestValues } from 'selectors/user/abTest'

const mapStateToProps = createStructuredSelector({
  isAuthenticated,
  abTest: getABTestValues,
})

export type ConnectorProps = {
  isAuthenticated: boolean
  abTest: Record<string, any>
}

export default connect(mapStateToProps)
